import angular from 'angular';

class RecapResponseNavigation {
  constructor(
    $scope,
    $q,
    LanguageService,
    LogService
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$q = $q;
    this.LanguageService = LanguageService;
    this.LogService = LogService;
    this._recapPageInfos = [];
    this._constructed = true;
  }

  $onInit() {
    const vm = this;
    vm.LogService.debug('RecapResponseNavigation $onInit');
    vm._updateSelectedPageInfo();

    vm.$scope.$on('displayLogicUpdated', () => {
      vm._updateSelectedPageInfo();
    });
  }

  set recapResponse(response) {
    this._recapResponse = response;
  }

  get recapResponse() {
    return this._recapResponse;
  }

  set visiblePageIndex(idx) {
    this._visiblePageIndex = idx;
    this._updateSelectedPageInfo();
  }

  get visiblePageIndex() {
    return this._visiblePageIndex;
  }

  set selectedPageInfo(info) {
    const vm = this;
    if (!info) {
      vm.LogService.debug("set selectedPageInfo to null? visiblePageIndex:", this.visiblePageIndex, "recapPageInfos:", this.recapPageInfos);
      return false;
    }
    const changed = (info !== this._selectedPageInfo) || (info.pageIndex !== this._selectedPageInfo.pageIndex);
    if (changed) {
      this._selectedPageInfo = info;
      vm.$scope.$emit('jumpToPage', { pageIndex: info.pageIndex });
    }
  }

  get selectedPageInfo() {
    return this._selectedPageInfo;
  }

  get recapPageInfos() {
    const newRecapPageInfos = this.buildRecapPageInfos();
    if (!this._recapPageInfos || !angular.equals(newRecapPageInfos, this._recapPageInfos)) {
      this._recapPageInfos = newRecapPageInfos;
    }
    return this._recapPageInfos;
  }

  get nextPageEnabled() {
    return this.visiblePageIndex < (this.recapPageInfos.length - 1);
  }

  get previousPageEnabled() {
    return this.visiblePageIndex > 0;
  }

  get visiblePageResponse() {
    const visiblePageResponses = this.recapResponse && this.recapResponse.visiblePageResponses || [];
    if (this.visiblePageIndex >= 0 && this.visiblePageIndex < visiblePageResponses.length) {
      return visiblePageResponses[this.visiblePageIndex];
    } else {
      return null;
    }
  }

  buildRecapPageInfos() {
    const vm = this;
    const visiblePageResponses = this.recapResponse && this.recapResponse.visiblePageResponses || [];
    // const visiblePages = this.recapResponse && this.recapResponse.visiblePages || [];
    const pageInfos = visiblePageResponses.map((pageResponse, idx) => {
      const page = pageResponse.page;
      const pageId = page.id;
      const touched = pageResponse.touched;
      const viewed = pageResponse.viewed;
      const valid = pageResponse.valid !== false;
      const selected = idx === this.visiblePageIndex;
      const translatedPageName = vm.LanguageService.translateProperty(page, 'name');
      const pageName = translatedPageName ? translatedPageName : `Page ${idx + 1}`;

      let labelPrefix;
      if (viewed) {
        if (valid) {
          labelPrefix = '✅ ';
        } else {
          labelPrefix = '❌ ';
        }
      } else {
        labelPrefix = '◻️ ';
      }

      const label = [labelPrefix, pageName].join('');
      const info = {
        // page,
        pageId,
        // pageResponse,
        label,
        selected,
        touched,
        viewed,
        valid,
        pageIndex: idx,
      };
      return info;
    });
    return pageInfos;
  }

  _updateSelectedPageInfo() {
    if (!this._constructed) return;
    if (this.recapPageInfos && this.recapPageInfos.length) {
      const idx = this.visiblePageIndex >= 0 ? this.visiblePageIndex : 0;
      this._selectedPageInfo = this.recapPageInfos[idx];
    }
  }

  selectedPageChanged() {
    this.LogService.debug("selectedPageChanged.. arguments:", arguments);
  }

  nextPage() {
    this.LogService.debug('nextPage()', this);
    this.$scope.$emit('nextPage', { pageResponse: this.visiblePageResponse });
  }

  previousPage() {
    this.LogService.debug('previousPage()', this);
    this.$scope.$emit('previousPage', { pageResponse: this.visiblePageResponse });
  }
}

export default RecapResponseNavigation;
